<!-- 历史数据 -->
<template>
  <j-modal :title="title" v-dragModal :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{  overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" :tab="$t('数据图形展示')">
          <a-radio-group :value="size" @change="handleTimeChange">
            <a-radio-button value="today">{{ $t('今日') }}</a-radio-button>
            <a-radio-button value="threeday">{{ $t('近三天') }}</a-radio-button>
            <a-radio-button value="week">{{ $t('近一周') }}</a-radio-button>
          </a-radio-group>
          <div id="main1" style="width: 100%;height: 300px;"></div>
          <div id="main2" style="width: 100%;height: 300px;"></div>
        </a-tab-pane>
        <a-tab-pane key="2" :tab="$t('数据列表')">
          <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  export default {
    mixins: [JeecgListMixin],
    name: 'modal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        url: {
          list: "/jeecg-charge/tyn/solarEnergyMeterElectricity/list",
        },
        queryParam:{
          meterId: ''
        }
      }
    },
    computed: {
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('当月累计充电量(KWH)'),
            align:"center",
            dataIndex: 'monthCharge'
          },
          {
            title: this.$t('当月累计用电量(KWH)'),
            align:"center",
            dataIndex: 'monthUseElectricity',
          },
          {
            title: this.$t('昨日充电量(KWH)'),
            dataIndex: 'yesterdayCharge',
            align:"center",
          },
          {
            title: this.$t('昨日用电量(KWH)'),
            align:"center",
            dataIndex: 'yesterdayUseElectricity',
          },
          {
            title: this.$t('日期'),
            align:"center",
            dataIndex: 'date'
          },
        ]
      },
    },
    methods: {
      init(row){
        this.visible = true;
        this.title = this.$t('用电历史数据');
        this.disableSubmit = true;
        this.queryParam.meterId = row.meterId;
        // this.loadData();
        },
        getData(val){
          let params = {
            meterId: val.meterId,
            state: val.state
          }
          postAction(this.url.queryGraphByTime,params).then(res=>{
            if(res.success){
              this.$nextTick(()=>{
                this.setMain1(res.result.timeList,res.result.mpaList,res.result.pvalueTop,res.result.pvalueLow);
                this.setMain2(res.result.timeList,res.result.templateList,res.result.tepvalueTop,res.result.tepvalueLow);
              })
            }
          })
        },
        setMain1(xData,yData,topY,lowY){
          var chartDom = document.getElementById('main1');
          var myChart = echarts.init(chartDom);
          var option;
          option = {
            grid:{
              bottom: '30%'
            },
            title:{
              text: this.$t('充电曲线图')
            },
            color: '#87d068',
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                animation: false
              }
            },
            xAxis: {
              type: 'category',
              data: xData,
            },
            yAxis: {
              type: 'value',
              name: 'MPa',
              min:0,
              max:topY,
            },
            series: [
              {
                data: yData,
                type: 'line',
                markLine: {
                  data: [
                    {yAxis: topY, name: this.$t('上限值'),symbol: 'circle',lineStyle:{color:'red',type:'dashed'},label:{formatter:'{b}:{c}'}},
                    {yAxis: lowY, name: this.$t('下限值'),symbol: 'circle',lineStyle:{color:'orange',type:'dashed'},label:{formatter:'{b}:{c}'}},
                  ]
                }
              }
            ]
          };
          if (yData && yData.length > 0) {

          } else {
              option.series[0].markLine.data = ''; // 不显示markLine
          }
          option && myChart.setOption(option);
        },
        setMain2(xData,yData,topY,lowY){
          var chartDom = document.getElementById('main2');
          var myChart = echarts.init(chartDom);
          var option;
          option = {
            grid:{
              bottom: '30%'
            },
            title:{
              text: this.$t('放电曲线图')
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                animation: false
              }
            },
            color: '#87d068',
            xAxis: {
              type: 'category',
              data: xData,
            },
            yAxis: {
              type: 'value',
              name: '℃',
              min:0,
              max:topY,
            },
            series: [
              {
                data: yData,
                type: 'line',
                markLine: {
                  data: [
                    {yAxis: topY, name: this.$t('上限值'),symbol: 'circle',lineStyle:{color:'red',type:'dashed'},label:{formatter:'{b}:{c}'}},
                    {yAxis: lowY, name: this.$t('下限值'),symbol: 'circle',lineStyle:{color:'orange',type:'dashed'},label:{formatter:'{b}:{c}'}},
                  ]
                }
              }
            ]
          };
          if (yData && yData.length > 0) {

          } else {
              option.series[0].markLine.data = ''; // 不显示markLine
          }
          option && myChart.setOption(option);
        },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>
